const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Header navigation timing constants
const HEADER_TIMING = {
  STICKY_THRESHOLD: 24, // pixels scrolled before header becomes sticky
  TRANSITION_DELAY: 100, // ms to wait for CSS transitions to complete
  NAVIGATION_DELAY: 10, // ms delay before navigation to allow UI feedback
  MEGAMENU_CLOSE_DELAY: 220, // ms hover delay before closing mega menu
  FOCUS_DELAY: 100, // ms delay before focusing element after modal opens
};
